import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { of } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'
import {
  CreateDiscountGroupFailure,
  CreateDiscountGroupRequest,
  CreateDiscountGroupSuccess,
  DeleteDiscountGroupFailure,
  DeleteDiscountGroupRequest,
  DeleteDiscountGroupSuccess,
  FetchDiscountGroupFailure,
  FetchDiscountGroupRequest,
  FetchDiscountGroupSuccess,
  FetchDiscountGroupsFailure,
  FetchDiscountGroupsRequest,
  FetchDiscountGroupsSuccess,
  UpdateDiscountGroupFailure,
  UpdateDiscountGroupRequest,
  UpdateDiscountGroupSuccess,
} from './discount-groups.actions'
import { DiscountGroupsService } from './discount-groups.service'
import * as Wards from './discount-groups.types'

@Injectable()
export class DiscountGroupsEffects {
  constructor(
    private actions: Actions,
    private discountGroupsService: DiscountGroupsService,
    private router: Router,
  ) {}

  FetchDiscountGroups$ = createEffect(() =>
    this.actions.pipe(
      ofType(Wards.FETCH_DISCOUNT_GROUPS_REQUEST),
      switchMap((action: FetchDiscountGroupsRequest) => {
        return this.discountGroupsService
          .fetchDiscountGroups(action.payload)
          .pipe(
            map((result) => {
              return new FetchDiscountGroupsSuccess(
                result.data.results,
                result.data.totalCount,
                result.data.filteredCount,
              )
            }),
            catchError((err, caught) => {
              return of(new FetchDiscountGroupsFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  FetchDiscountGroup$ = createEffect(() =>
    this.actions.pipe(
      ofType(Wards.FETCH_DISCOUNT_GROUP_REQUEST),
      switchMap((action: FetchDiscountGroupRequest) => {
        return this.discountGroupsService.fetchDiscountGroup(action.id).pipe(
          map((result) => {
            return new FetchDiscountGroupSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchDiscountGroupFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  DeleteDiscountGroup$ = createEffect(() =>
    this.actions.pipe(
      ofType(Wards.DELETE_DISCOUNT_GROUP_REQUEST),
      switchMap((action: DeleteDiscountGroupRequest) => {
        return this.discountGroupsService.deleteDiscountGroup(action.id).pipe(
          switchMap(() => {
            return [new DeleteDiscountGroupSuccess()]
          }),
          catchError((err, caught) => {
            return of(new DeleteDiscountGroupFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  CreateDiscountGroup$ = createEffect(() =>
    this.actions.pipe(
      ofType(Wards.CREATE_DISCOUNT_GROUP_REQUEST),
      switchMap((action: CreateDiscountGroupRequest) => {
        return this.discountGroupsService
          .createDiscountGroup(action.payload)
          .pipe(
            switchMap(() => {
              this.router.navigate(['/admin/discount-groups'])
              return [new CreateDiscountGroupSuccess()]
            }),
            catchError(() => {
              return of(new CreateDiscountGroupFailure({}))
            }),
          )
      }),
    ),
  )

  UpdateDiscountGroup$ = createEffect(() =>
    this.actions.pipe(
      ofType(Wards.UPDATE_DISCOUNT_GROUP_REQUEST),
      switchMap((action: UpdateDiscountGroupRequest) => {
        return this.discountGroupsService
          .updateDiscountGroup(action.id, action.payload)
          .pipe(
            switchMap(() => {
              this.router.navigate(['/admin/discount-groups'])
              return [new UpdateDiscountGroupSuccess()]
            }),
            catchError(() => {
              return of(new UpdateDiscountGroupFailure({}))
            }),
          )
      }),
    ),
  )
}
